"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var online_drivers_ed_settings_controller_1 = __importDefault(require("./online-drivers-ed-settings.controller"));
var online_drivers_ed_settings_html_1 = __importDefault(require("./online-drivers-ed-settings.html"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.settings.policies.ca_ode", {
        url: "/online-drivers-ed",
        controller: online_drivers_ed_settings_controller_1.default,
        controllerAs: "vm",
        template: online_drivers_ed_settings_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.student,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.settings.policies.onlinedriversed", [])
    .config(config)
    .controller("AdminSettingsOnlineDriversEdController", online_drivers_ed_settings_controller_1.default);
